import { css } from "styled-components";
import omit from "lodash/omit";

var fontSizes = {
  xxs: "0.6em",
  xs: "0.75em", // 12px
  small: "0.875em", // 14px
  normal: "1em", // 16px
  large: "1.2em",
  xl: "1.5em",
  xxl: "2em"
};

export var omitCommonProps = function omitCommonProps(props) {
  return omit(props, ["bold", "color", "size", "center", "noUnderline", "dividing", "icon", "fluid", "basic", "inverted", "right"]);
};

export default css(["", ";", ";", ";", ";", ";"], function (props) {
  return props.bold && css(["font-weight:600;"]);
}, function (props) {
  return props.color && css(["color:", ";"], function (props) {
    return props.theme[props.color];
  });
}, function (props) {
  return props.size && css(["font-size:", ";"], fontSizes[props.size]);
}, function (props) {
  return props.center && css(["display:block;text-align:center;"]);
}, function (props) {
  return props.fluid && css(["display:block;"]);
});